export default __webpack_public_path__ + "static/media/ToDoApp.30928556.jpg";